import { Outlet, useParams } from 'react-router-dom';

import { useGetBuildingsByIdQuery } from '@client/api';
import { PageDetailContent, useIsUsageType } from '@client/toolkit';

import { CommercialSpacesListCard } from '../../../components/commercial-spaces-list-card/commercial-spaces-list-card.component';
import { CommonAreasListCard } from '../../../components/common-areas-list-card/common-areas-list-card.component';
import { BuildingParkingSpotsCard } from '../dashboard/components/building-parking-spots/building-parking-spots-card.component';
// COMMENTED OUT: "Enheter" box hidden — uncomment to restore
// import { ResidentialUnitsCard } from '../dashboard/components/residential-units-card.component';
import { PageContentAnimation } from '../../../../../components/layout/page-content-animation';

export function BuildingArealerRoute() {
  const { buildingId } = useParams<{ buildingId: string }>();

  const { data: building } = useGetBuildingsByIdQuery({ id: buildingId ?? '' }, { skip: !buildingId });

  const { isCommercialOrMixed } = useIsUsageType(building?.usageType);

  return (
    <>
      <PageDetailContent align="left">
        <PageContentAnimation>
          <div className="space-y-2">
            {(building?.usageType == null || isCommercialOrMixed) && (
              <>
                <CommercialSpacesListCard />
                <CommonAreasListCard />
                <BuildingParkingSpotsCard />
              </>
            )}

            {/* COMMENTED OUT: "Enheter" box hidden — uncomment to restore
            {(building?.usageType == null || isResidentialOrMixed) && <ResidentialUnitsCard />}
            */}
          </div>
        </PageContentAnimation>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
